import { Box, Typography } from '@mui/material';
import { AlarmConditionItem } from 'src/features/alarms/components/alarm-condition-item';
import { ConditionItem } from 'src/types/alarms';
import { formatUTCDateToLocal } from 'src/utilities';
import { conditionsBox, titleStyle } from '../conditionSectionItem/style';
import { TextRowItem } from '../textRowItem';

type Props = {
  title: string;
  checkedAt?: string;
  lastPayloadReceived?: string;
  payloadInterval?: number;
  conditions?: ConditionItem[];
  reason?: string;
};

export const AlarmCommunicationItem = ({
  title,
  checkedAt,
  lastPayloadReceived,
  payloadInterval,
  conditions,
  reason,
}: Props) => (
  <Box>
    <Typography sx={titleStyle}>{title}</Typography>

    {reason && <Typography>{reason}</Typography>}

    {checkedAt && (
      <TextRowItem description="Checked at:" value={formatUTCDateToLocal(false, checkedAt)} />
    )}
    {lastPayloadReceived && (
      <TextRowItem
        description="Last Payload Received:"
        value={formatUTCDateToLocal(false, lastPayloadReceived)}
      />
    )}
    {payloadInterval && <TextRowItem description="Payload Interval:" value={payloadInterval} />}

    <Box sx={conditionsBox}>
      {conditions?.map((condition, i: number) => {
        const isExtendedRow = i > 0;
        return (
          <AlarmConditionItem
            key={condition.inputId}
            isExtendedRow={isExtendedRow}
            condition={condition}
          />
        );
      })}
    </Box>
  </Box>
);
